import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6e0bd78c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "k-line-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "14px",
    "width": "1px",
    "background-color": "#969799",
    "margin": "0 12px"
  }
}, null, -1));

const _hoisted_4 = {
  style: {
    "font-size": "18px",
    "font-weight": "700"
  }
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  class: "header-l"
};
const _hoisted_7 = {
  style: {
    "font-size": "13px",
    "line-height": "100%",
    "font-weight": "700",
    "letter-spacing": "-0.5px"
  }
};
const _hoisted_8 = {
  class: "header-r"
};
const _hoisted_9 = {
  class: "info-line"
};
const _hoisted_10 = {
  class: "info-item",
  style: {
    "padding-bottom": "10px"
  }
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "value"
};
const _hoisted_13 = {
  class: "info-item"
};
const _hoisted_14 = {
  class: "label"
};
const _hoisted_15 = {
  class: "value"
};
const _hoisted_16 = {
  class: "info-item"
};
const _hoisted_17 = {
  class: "label"
};
const _hoisted_18 = {
  class: "value"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "16",
  width: "35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M14 25H7V14H0V7h14v18ZM35.5 7 28 25h-8l7.5-18h8ZM20 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  fill: "currentColor",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd"
})], -1));

const _hoisted_20 = {
  style: {
    "padding": "5px 0",
    "border-radius": "5px",
    "background-color": "var(--atbg-color)"
  }
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("MACD");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("BOLL");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("KDJ");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("RSI");

const _hoisted_25 = {
  style: {
    "margin": "0 5px 0 5px",
    "color": "#F08504"
  }
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "kline-chart",
  style: {
    "height": "660px"
  }
}, null, -1));

const _hoisted_27 = {
  key: 0,
  class: "kline-info deal"
};
const _hoisted_28 = {
  class: "info-header"
};
const _hoisted_29 = {
  class: "time"
};
const _hoisted_30 = {
  class: "direction"
};
const _hoisted_31 = {
  class: "price"
};
const _hoisted_32 = {
  class: "num"
};
const _hoisted_33 = {
  class: "time"
};
const _hoisted_34 = {
  key: 0,
  class: "direction",
  style: {
    "color": "#04AC92"
  }
};
const _hoisted_35 = {
  key: 1,
  class: "direction",
  style: {
    "color": "#D04C64"
  }
};
const _hoisted_36 = {
  class: "num"
};
const _hoisted_37 = {
  class: "btn-area"
};
import { ref, onMounted, onBeforeUnmount, watch, onUpdated, onActivated } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import { CaretDownOutlined, LeftOutlined, RiseOutlined, FallOutlined } from '@ant-design/icons-vue';
import { dispose, init } from 'klinecharts';
import CustomPopupList from '@/components/CustomPopupList.vue';
import TradeProductItem from '@/components/TradeProductItem.vue';
import wssId from '@/util/wssId';
import { formatDate } from '@/util'; // import BigNumber from 'bignumber.js'

import { useI18n } from "vue-i18n";
import TradingViewKline from '@/components/charts/TradingViewKline.vue';
export default {
  __name: 'KLineView1',

  setup(__props) {
    const {
      t
    } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const tradingViewRef = ref(null);
    const segmentedValue = ref('Original');

    const segmentedChange = index => {
      if (index.target.value == 'Original') {// chart.removeTechnicalIndicator('vol_pane', 'VOL')
        // chart.createTechnicalIndicator('CR', false, {
        //   id: 'pane_1',
        //   dragEnabled: true,
        // });
        // chart.removeTechnicalIndicator('pane_1', 'CR')
        // chart.createTechnicalIndicator({ name: 'VOL', calcParams: [10], styles: { margin: { top: 0.2, bottom: 2 } } }, false, { id: 'vol_pane' })
      }

      if (index.target.value == 'TradingView') {
        tradingViewRef.value.tvInit(); // timeChange()
      }
    };

    let wss = null;
    const wssConnect = ref(false);
    let wssHeart = null;
    let first = ref(true);
    const last = ref({
      price: '0.00',
      up: true,
      growth: '0.00'
    });
    let chart = null;
    const klineKey = ref('');
    const klineActive = ref(0);
    const klineSecond = [60, 300, 900, 1800, 3600, 86400, 604800]; // let now = Math.floor(new Date().getTime()/1000)

    const ieoKey = ref('WTCUSDT');
    const dealList = ref([]);
    let dealTimer = null;
    let leaving = false;
    const listShow = ref(false);
    const showPopover = ref(false);
    const indicatorList = ref([]);
    let indicatorKey = {};
    const dataList = ref({});
    let dataTimer = null;
    const lastKline = ref(null); //query查询上一次的0位数值

    const precision = watch([store.state.marketInfo], () => {
      const klineInfo = store.state.marketInfo[klineKey.value];

      if (klineInfo) {
        chart.setPriceVolumePrecision(klineInfo.decimal, klineInfo.decimal);
      }

      precision();
    });
    watch(() => store.state.lang, () => {
      if (segmentedValue.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }
    });

    const dataChange = () => {
      dataTimer = setInterval(() => {
        dataList.value = { ...store.state.market
        };
      }, 1200);
    };

    const fmtTime = ts => {
      return formatDate(ts, 'hh:mm:ss');
    };

    let klineLoading = false;

    const klineMore = () => {
      if (klineLoading) {
        setTimeout(klineMore, 1000);
        return;
      }

      klineLoading = true;

      if (klineKey.value !== '' && wssConnect.value && wss) {
        // const diff = BigNumber(klineSecond[klineActive.value]).multipliedBy(300).toNumber()
        // const form = BigNumber(now).minus(diff).toNumber()
        let lk = lastKline.value ? String(lastKline.value[0]) : '';
        wss.send(JSON.stringify({
          id: wssId['kline.query'],
          method: 'kline.query',
          params: [klineKey.value, String(klineSecond[klineActive.value]), lk]
        }));
      } else {
        klineLoading = false;
      }
    };

    const timeChange = () => {
      if (segmentedValue.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }

      tradingViewRef.value.chartData = [];
      wss.send(JSON.stringify({
        id: wssId['kline.unsubscribe'],
        method: 'kline.unsubscribe',
        params: []
      }));
      first.value = true; // now = Math.floor(new Date().getTime()/1000)

      lastKline.value = null;
      klineMore();
    };

    const klineKeyChange = key => {
      if (segmentedValue.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }

      tradingViewRef.value.chartData = [];
      wss.send(JSON.stringify({
        id: wssId['kline.unsubscribe'],
        method: 'kline.unsubscribe',
        params: []
      }));
      klineKey.value = key;
      listShow.value = false;
      first.value = true; // now = Math.floor(new Date().getTime()/1000)

      lastKline.value = null;
      klineMore();
    };

    const dealSend = () => {
      if (ieoKey.value === klineKey.value) {
        clearInterval(dealTimer);
        return;
      }

      dealTimer = setInterval(() => {
        if (wssConnect.value && wss) {
          wss.send(JSON.stringify({
            id: wssId['deals.query'],
            method: 'deals.info',
            params: [klineKey.value, '30']
          }));
        }
      }, 2000);
    };

    const indicatorChange = name => {
      if (indicatorList.value.includes(name)) {
        if (name == "RSI") indicatorKey[name] = chart.createTechnicalIndicator({
          name: 'RSI',
          calcParams: [12],
          precision: 4
        }, false, {
          height: 90
        });else indicatorKey[name] = chart.createTechnicalIndicator(name, false, {
          height: 90
        });
      } else {
        if (indicatorKey[name]) {
          chart.removeTechnicalIndicator(indicatorKey[name]);
        }
      }
    };

    onMounted(async () => {
      dataList.value = { ...store.state.market
      };
      dataChange();
      chart = init('kline-chart', {
        candle: {
          tooltip: {
            showRule: 'follow_cross',
            showType: 'rect',
            labels: [t('time'), t('open'), t('close'), t('high'), t('low'), t('volume')]
          }
        }
      });
      chart.setTimezone('America/New_York');
      chart.setOffsetRightSpace(20);
      chart.createTechnicalIndicator({
        name: 'VOL',
        calcParams: [10],
        styles: {
          margin: {
            top: 0.2,
            bottom: 2
          }
        }
      });
      chart.createTechnicalIndicator({
        name: 'MA',
        shortName: 'MA',
        calcParams: [10, 20, 30],
        dragEnabled: true,
        plots: [{
          key: 'ma1',
          title: 'MA10: ',
          type: 'line'
        }, {
          key: 'ma2',
          title: 'MA20: ',
          type: 'line'
        }, {
          key: 'ma3',
          title: 'MA30: ',
          type: 'line'
        }],
        regeneratePlots: params => {
          return params.map((p, i) => {
            return {
              key: `ma${i + 1}`,
              title: `MA${p}: `,
              type: 'line'
            };
          });
        }
      }, true, {
        id: 'candle_pane',
        dragEnabled: true
      });

      if (route.query.key && route.query.key !== '') {
        klineKey.value = route.query.key;
      } else {
        if (store.state.homeKey.length > 0) {
          klineKey.value = store.state.homeKey[0];
        }
      }

      chart.loadMore(klineMore);
      wssInit();
    });
    let closeHeart = null;
    let restart = false;

    const wssInit = () => {
      clearInterval(wssHeart);
      clearInterval(dealTimer);
      wss = new WebSocket(process.env.VUE_APP_WSS);

      wss.onopen = () => {
        wssConnect.value = true;
        klineMore();
        dealSend();
        wssHeart = setInterval(() => {
          if (wssConnect.value && wss) {
            wss.send(1);
          }
        }, 10000);

        if (segmentedValue.value == 'TradingView') {
          tradingViewRef.value.tvInit();
        }
      };

      wss.onmessage = res => {
        const data = JSON.parse(res.data);

        if (data.method) {
          switch (data.method) {
            case 'kline.query':
              data.result.forEach((item, index) => {
                if (index == 0) lastKline.value = item;
              });
              if (segmentedValue.value == 'TradingView' && tradingViewRef.value.tvHistoryFunction) tradingViewRef.value.tvHistoryFunction(data);

              if (first.value) {
                const klineInfo = store.state.marketInfo[klineKey.value];

                if (klineInfo) {
                  chart.setPriceVolumePrecision(klineInfo.decimal, klineInfo.decimal);
                }

                chart.applyNewData(data.result.map((item, index) => {
                  if (index == data.result.length - 1) //k线和update刚开始同步显示
                    last.value = {
                      price: Number(item[2])
                    };
                  return {
                    timestamp: Number(item[0] * 1000),
                    open: Number(item[1]),
                    high: Number(item[3]),
                    low: Number(item[4]),
                    close: Number(item[2]),
                    volume: Number(item[5])
                  };
                }), data.result.length >= 300); // if (data.result.length > 0) {
                //   now = BigNumber(data.result[0][0]).minus(klineSecond[klineActive.value]).toNumber()
                // }

                first.value = false;
                wss.send(JSON.stringify({
                  id: wssId['kline.subscribe'],
                  method: 'kline.subscribe',
                  params: [klineKey.value, String(klineSecond[klineActive.value])]
                }));
              } else {
                chart.applyMoreData(data.result.map(item => {
                  return {
                    timestamp: Number(item[0] * 1000),
                    open: Number(item[1]),
                    high: Number(item[3]),
                    low: Number(item[4]),
                    close: Number(item[2]),
                    volume: Number(item[5])
                  };
                }), data.result.length >= 300); // if (data.result.length > 0) {
                //   now = BigNumber(data.result[0][0]).minus(klineSecond[klineActive.value]).toNumber()
                // }
              }

              if (restart) {
                wss.send(JSON.stringify({
                  id: wssId['kline.unsubscribe'],
                  method: 'kline.unsubscribe',
                  params: []
                }));
                wss.send(JSON.stringify({
                  id: wssId['kline.subscribe'],
                  method: 'kline.subscribe',
                  params: [klineKey.value, String(klineSecond[klineActive.value])]
                }));
                restart = false;
              } //保存k线数据，给tradingview使用


              var arr = [];

              for (var i = 0; i < data.result.length; i++) {
                var item = data.result[i];
                arr.push({
                  time: item[0] * 1000,
                  open: Number(item[1]),
                  high: Number(item[3]),
                  low: Number(item[4]),
                  close: Number(item[2]),
                  volume: Number(item[5])
                });
              }

              arr.push(...tradingViewRef.value.chartData);
              tradingViewRef.value.chartData = arr;
              klineLoading = false;
              break;

            case 'kline.update':
              if (segmentedValue.value == 'TradingView' && tradingViewRef.value.tvScribeFunction != null) tradingViewRef.value.tvScribeFunction(data);

              if (data.result) {
                let growth = '0.00';
                let up = true;

                if (data.result[2] > 0) {
                  growth = (Math.ceil(Math.abs(data.result[2] - data.result[1]) / data.result[2] * 10000) / 100).toFixed(2);
                }

                if (data.result[1] > data.result[2]) {
                  growth = `-${growth}`;
                  up = false;
                } else {
                  growth = `+${growth}`;
                }

                last.value = {
                  price: data.result[2],
                  up: up,
                  growth: growth
                };
                chart.updateData({
                  timestamp: Number(data.result[0] * 1000),
                  open: Number(data.result[1]),
                  high: Number(data.result[3]),
                  low: Number(data.result[4]),
                  close: Number(data.result[2]),
                  volume: Number(data.result[5])
                });
              }

              break;

            case 'deals.info':
              dealList.value = data.result;
              dealList.value = dealList.value.map(item => {
                return JSON.parse(item);
              });
              break;
          }
        }
      };

      wss.onclose = () => {
        if (!leaving) {
          clearInterval(wssHeart);
          wssConnect.value = false;
          restart = true;
          clearInterval(dealTimer);
          closeHeart = setTimeout(() => {
            if (!leaving) {
              wssInit();
            }
          }, 5000);
        }
      };
    };

    const goToTrade = type => {
      if (klineKey.value === ieoKey.value) {
        router.replace({
          name: 'ieo',
          query: {
            type: type,
            active: 1
          }
        });
        return;
      }

      switch (route.query.type) {
        case 'trade':
          router.replace({
            name: 'trade',
            query: {
              type: type
            }
          });
          break;

        case 'second':
          router.replace({
            name: 'futures',
            query: {
              type: type,
              active: 1
            }
          });
          break;

        case 'contract':
          router.replace({
            name: 'futures',
            query: {
              type: type,
              active: 0
            }
          });
          break;

        case 'ieo':
          router.replace({
            name: 'ieo',
            query: {
              type: type,
              active: 1
            }
          });
      }
    };

    onBeforeUnmount(() => {
      leaving = true;
      clearTimeout(closeHeart);
      dispose('kline-chart');
      clearInterval(dealTimer);
      clearInterval(wssHeart);
      clearInterval(dataTimer);

      if (wssConnect.value || wss) {
        wss.close();
      }
    });

    const getKlineNum = name => {
      const key = klineKey.value;
      return dataList.value[key] ? Number(dataList.value[key][name]).toFixed(4) : '0.00';
    };

    onUpdated(() => {
      //切换日夜模式时切换网格线的显示
      let bol = true;

      if (localStorage.getItem('isLight') == undefined || localStorage.getItem('isLight') == null || localStorage.getItem('isLight') == 'true') {
        bol = true;
      } else {
        bol = false;
      }

      chart.setStyleOptions({
        grid: {
          show: bol
        }
      });
    }); // onActivated(()=>{
    //   tradingViewRef.value.tvInit()
    // })

    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");

      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_tabs = _resolveComponent("van-tabs");

      const _component_a_radio_button = _resolveComponent("a-radio-button");

      const _component_a_radio_group = _resolveComponent("a-radio-group");

      const _component_van_checkbox = _resolveComponent("van-checkbox");

      const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");

      const _component_van_popover = _resolveComponent("van-popover");

      const _component_van_button = _resolveComponent("van-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        class: "k-line-nb",
        "safe-area-inset-top": true,
        fixed: true,
        placeholder: true,
        "z-index": "200",
        border: false
      }, {
        left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(LeftOutlined), {
          style: {
            "font-size": "20px",
            "color": "var(--text-color)"
          },
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }), _hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(store).state.marketInfo[klineKey.value]?.name), 1), _createVNode(_unref(CaretDownOutlined), {
          style: {
            "font-size": "20px",
            "color": "var(--text-color)",
            "margin-left": "10px"
          },
          onClick: _cache[1] || (_cache[1] = $event => listShow.value = true)
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "title",
        style: _normalizeStyle({
          color: last.value.up ? '#2eb266' : '#D04C64'
        })
      }, _toDisplayString(Number(last.value.price).toFixed(_unref(store).state.marketInfo[klineKey.value]?.decimal)), 5), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
        style: _normalizeStyle([{
          color: last.value.up ? '#2eb266' : '#D04C64'
        }, {
          "margin-left": "10px"
        }])
      }, _toDisplayString(last.value.growth) + "%", 5)]), last.value.up ? (_openBlock(), _createBlock(_unref(RiseOutlined), {
        key: 0,
        style: {
          "color": "#2eb266",
          "margin-left": "5px",
          "font-size": "18px"
        }
      })) : (_openBlock(), _createBlock(_unref(FallOutlined), {
        key: 1,
        style: {
          "color": "#D04C64",
          "margin-left": "5px",
          "font-size": "18px"
        }
      }))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('high24H')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(getKlineNum('high')), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('low24H')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(getKlineNum('low')), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('num24H')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(getKlineNum('volume')), 1)])])])]), _createVNode(TradingViewKline, {
        ref_key: "tradingViewRef",
        ref: tradingViewRef,
        segmentedValue: segmentedValue.value,
        klineActive: klineActive.value,
        decimal: _unref(store).state.marketInfo[klineKey.value]?.decimal,
        klineKey: klineKey.value,
        first: _unref(first),
        klineSecond: klineSecond,
        onKlineMore: klineMore
      }, {
        time: _withCtx(() => [_createVNode(_component_van_tabs, {
          active: klineActive.value,
          "onUpdate:active": _cache[2] || (_cache[2] = $event => klineActive.value = $event),
          onClickTab: timeChange,
          shrink: "",
          style: {
            "--van-tab-font-size": "13px",
            "--van-tabs-bottom-bar-width": "20px",
            "--van-tabs-line-height": "30px",
            "--van-padding-sm": "6px",
            "--van-tabs-bottom-bar-color": "#F08504"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, {
            title: `1${_unref(t)('minute')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `5${_unref(t)('minute')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `15${_unref(t)('minute')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `30${_unref(t)('minute')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `1${_unref(t)('hour')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `1${_unref(t)('day')}`
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: `1${_unref(t)('week')}`
          }, null, 8, ["title"])]),
          _: 1
        }, 8, ["active"])]),
        segmented: _withCtx(() => [_createVNode(_component_a_radio_group, {
          value: segmentedValue.value,
          "onUpdate:value": _cache[3] || (_cache[3] = $event => segmentedValue.value = $event),
          onChange: segmentedChange,
          "button-style": "solid",
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_button, {
            value: "Original"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('original')), 1)]),
            _: 1
          }), _createVNode(_component_a_radio_button, {
            value: "TradingView"
          }, {
            default: _withCtx(() => [_hoisted_19]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"])]),
        indicator: _withCtx(() => [_createVNode(_component_van_popover, {
          show: showPopover.value,
          "onUpdate:show": _cache[9] || (_cache[9] = $event => showPopover.value = $event),
          placement: "bottom-end"
        }, {
          reference: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('indicator')), 1)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_van_checkbox_group, {
            modelValue: indicatorList.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => indicatorList.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "MACD",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[4] || (_cache[4] = $event => indicatorChange('MACD'))
            }, {
              default: _withCtx(() => [_hoisted_21]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "BOLL",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[5] || (_cache[5] = $event => indicatorChange('BOLL'))
            }, {
              default: _withCtx(() => [_hoisted_22]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "KDJ",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[6] || (_cache[6] = $event => indicatorChange('KDJ'))
            }, {
              default: _withCtx(() => [_hoisted_23]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "RSI",
              onClick: _cache[7] || (_cache[7] = $event => indicatorChange('RSI'))
            }, {
              default: _withCtx(() => [_hoisted_24]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }, 8, ["show"])]),
        chart: _withCtx(() => [_hoisted_26]),
        _: 1
      }, 8, ["segmentedValue", "klineActive", "decimal", "klineKey", "first"]), ieoKey.value !== klineKey.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('time')), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('direction')), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('price')), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('number')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "deal-item"
        }, [_createElementVNode("div", _hoisted_33, _toDisplayString(fmtTime(item.time)), 1), item.type == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(t)('buy')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(t)('sell')), 1)), _createElementVNode("div", {
          class: "price",
          style: _normalizeStyle({
            color: item.type == '0' ? '#04AC92' : '#D04C64'
          })
        }, _toDisplayString(item.price), 5), _createElementVNode("div", _hoisted_36, _toDisplayString(Number(item.amount).toFixed(_unref(store).state.marketInfo[klineKey.value]?.decimal)), 1)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createVNode(_component_van_button, {
        color: "#04AC92",
        block: "",
        style: {
          "width": "48%",
          "--van-button-default-height": "39px"
        },
        onClick: _cache[10] || (_cache[10] = $event => goToTrade(1))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('buy')), 1)]),
        _: 1
      }), _createVNode(_component_van_button, {
        color: "#D04C64",
        block: "",
        style: {
          "width": "48%",
          "--van-button-default-height": "39px"
        },
        onClick: _cache[11] || (_cache[11] = $event => goToTrade(2))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('sell')), 1)]),
        _: 1
      })]), _createVNode(CustomPopupList, {
        "c-show": listShow.value,
        title: _unref(t)('markets'),
        onHide: _cache[12] || (_cache[12] = () => {
          listShow.value = false;
        })
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.marketCommodities, (item, key) => {
          return _openBlock(), _createBlock(TradeProductItem, {
            key: key,
            name: key,
            last: dataList.value[key]?.last,
            up: dataList.value[key]?.up,
            onClick: $event => klineKeyChange(key),
            icon: item?.icon
          }, null, 8, ["name", "last", "up", "onClick", "icon"]);
        }), 128))]),
        _: 1
      }, 8, ["c-show", "title"])]);
    };
  }

};